<template>
  <div class="container">
    <BackBar color="#295661" />
    <div class="titulo-subtitulo">
      <h2>Informes do IPAAM</h2>
      <p>Acompanhe aqui as notícias mais recentes do IPAAM</p>
    </div>
    <!-- Destaques Section -->
    <section
      v-for="informe in informes"
      :key="informe.id"
      class="informe"
      @click="goToInforme(informe.id)"
    >
      <div class="content">
        <div class="text">
          <h3 class="title">{{ informe.title }}</h3>
          <p class="section-label">{{ informe.subtitle }}</p>
          <p class="description">
            {{ truncateText(informe.content, 300) }}
            <button v-if="informe.content.length > 300" class="ver-mais">
              Ver mais
            </button>
          </p>
        </div>
      </div>
      <img :src="informe.urlImage" :alt="informe.titulo" class="informe-img" />
    </section>
  </div>
</template>

<script>
import axios from "axios";
import BackBar from "../layouts/BackBar.vue";
import { fetchInformes } from "../../services/informesService";

export default {
  name: "InformesIpaam",
  components: {
    BackBar
  },
  data() {
    return {
      informes: [],
      cards: [],
      expandedIds: [] // IDs dos itens expandidos
    };
  },
  mounted() {
    this.fetchInformes();
  },
  methods: {
    async fetchInformes() {
      try {
        const data = await fetchInformes();
        this.informes = data;
        this.cards = data;
      } catch (error) {
        console.error("Erro ao buscar os informes:", error);
      }
    },
    goToInforme(id) {
      this.$router.push({ name: "InformeDetalhe", params: { id } });
    },
    truncateText(text, limit) {
      return text.length <= limit ? text : text.substring(0, limit) + "...";
    },
    toggleExpand(id) {
      if (this.expandedIds.includes(id)) {
        this.expandedIds = this.expandedIds.filter(
          expandedId => expandedId !== id
        );
      } else {
        this.expandedIds.push(id);
      }
    },
    isExpanded(id) {
      return this.expandedIds.includes(id);
    }
  }
};
</script>

<style scoped>
.container {
  font-family: "Nunito", sans-serif;
}

.titulo-subtitulo h2 {
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 25px 0 3px 0;
}

.titulo-subtitulo p {
  color: #295661;
}

.titulo-subtitulo {
  margin-bottom: 26px;
}

.search-bar {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}

.search-bar input {
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 200px;
}

.informe {
  display: flex;
  background: white;
  margin-bottom: 20px;
  border-radius: 10px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  cursor: pointer;
}

.informe .content {
  padding: 20px;
}

.informe .content h3 {
  color: #295661;
  font-size: 32px;
  font-style: normal;
  font-weight: 800;
  line-height: normal;
  margin: 0 0 10px 0;
}

.informe .text {
  flex: 1;
  min-width: 250px;
}

.informe-img {
  width: 450px;
  height: auto;
  margin-left: 20px;
}

.section-label {
  font-size: 14px;
  color: #295661;
  font-weight: 600;
  margin-bottom: 20px;
}

.title {
  font-size: 20px;
  font-weight: 700;
  color: #003e52;
  margin: 10px 0;
}

.description {
  font-size: 15px;
  color: #3f3f3f;
  font-weight: 400;
}

.cards {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
}

.card {
  background: white;
  border-radius: 10px;
  padding: 15px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 320px;
  display: flex;
  gap: 15px;
}

.card img {
  width: 80px;
  height: 80px;
  border-radius: 8px;
  object-fit: cover;
}

.title-small {
  font-size: 16px;
  font-weight: bold;
  color: #003e52;
}

.description-small {
  font-size: 13px;
  color: #555;
}

.ver-mais {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-weight: bold;
  margin-left: 5px;
  padding: 0;
}

.ler-mais {
  background: none;
  border: none;
  color: #007bff;
  cursor: pointer;
  font-weight: bold;
  margin-left: 5px;
  padding: 0;
}

@media (max-width: 768px) {
  .informe {
    flex-direction: column;
  }

  .informe-img {
    margin: 20px 0 0 0;
    width: 100%;
  }

  .cards {
    flex-direction: column;
  }
}
</style>
